import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
const baseUrl = process.env.REACT_APP_API_BASE_URL


const quizApi = createApi({
    reducerPath: 'quizApi',
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (Headers: Headers, api) => {
            const token = localStorage.getItem("token");
            token && Headers.append("Authorization", "Bearer " + token)
        }
    }),
    tagTypes: ['Quiz'],
    endpoints: (builder) => ({
        getQuizes: builder.query({
            query: () => ({
                url: 'Quiz',

            }),
            providesTags: ['Quiz'],
        }),
        getQuizById: builder.query({
            query: (quizId) => ({
                url: `Quiz/${quizId}`,

            }),
            providesTags: ['Quiz'],
        }),
        getNextQuiz: builder.query({
            query: (userId) => `Quiz/GetNextQuizForUser?userId=${userId}`,
            providesTags: ['Quiz'],
        }),
        createQuiz: builder.mutation({
            query: (formData) => ({
                url: "Quiz",
                method: "POST",
                body: formData
            }),
            invalidatesTags: ["Quiz"],
        }),
        updateQuiz: builder.mutation({
            query: ({ data, id }) => ({
                url: `Quiz/${id}`,
                method: "PUT",
                body: data
            }),
            invalidatesTags: ["Quiz"],
        }),
        updateQuizStatus: builder.mutation({
            query: ({ id, isActive }) => ({
                url: `Quiz/${id}/status`,
                method: "PATCH",
                body: { id, isActive },
            }),
            invalidatesTags: ["Quiz"],
        }),
        deleteQuiz: builder.mutation({
            query: ({ id }) => ({
                url: `Quiz/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["Quiz"],
        }),
    }),
});

export const {
    useGetQuizesQuery,
    useGetQuizByIdQuery,
    useGetNextQuizQuery,
    useCreateQuizMutation,
    useUpdateQuizMutation,
    useUpdateQuizStatusMutation,
    useDeleteQuizMutation

} = quizApi;
export default quizApi;